import { TextField } from "@material-ui/core";
import DevelopIcon from "components/develop-icon/DevelopIcon";

import Collapse from "../../../components/collapse";
import mainClasses from "../AgentChatTicket.module.css";

const SendingSMS = () => {
  return (
    <Collapse
      title={
        <span className={`${mainClasses.title}`}>
          Gửi tin nhắn SMS <DevelopIcon />
        </span>
      }
      titleIcon={<i className={`fas fa-sms ${mainClasses.iconTitle}`} />}>
      <div className={mainClasses.row}>
        <div className={mainClasses.label}>Số điện thoại nhận</div>
        <TextField
          variant="outlined"
          InputProps={{
            spellCheck: "false",
            classes: {
              input: mainClasses.input,
            },
          }}
          fullWidth
        />
      </div>

      <div className={mainClasses.row}>
        <span className={mainClasses.label}>Nội dung gửi</span>
        <TextField
          variant="outlined"
          fullWidth
          multiline
          InputProps={{
            spellCheck: "false",
            classes: {
              multiline: mainClasses.input,
            },
          }}
          rows={3}
        />
      </div>
    </Collapse>
  );
};

export default SendingSMS;
